import { CartActionType } from "../utils/actions";

export interface CartProductType {
  id: number;
  brand: string;
  name: string;
  price: number;
  imageUrl?: string;
  category?: string;
  quantity: number;
}

interface CartState {
  cartItems: CartProductType[];
}

interface CartAction {
  type: CartActionType;
  payload?: {
    id: number;
    brand: string;
    name: string;
    price: number;
    quantity: number;
    category?: string;
    imageUrl?: string;
  };
}

export const UseStorage = (cartItems: CartProductType[]) => {
  localStorage.setItem(
    "cart",
    JSON.stringify(cartItems.length > 0 ? cartItems : [])
  );
};

export const sumItems = (
  cartItems: CartProductType[]
): { itemCount: number; totalAmount: number } => {
  UseStorage(cartItems);
  const itemCount = cartItems.reduce(
    (total, product) => total + product.quantity,
    0
  );
  const totalAmount = cartItems.reduce(
    (total, product) => total + product.price * product.quantity,
    0
  );
  return { itemCount, totalAmount };
};

const CartReducer = (state: CartState, action: CartAction) => {
  switch (action.type) {
    case CartActionType.AddItem: {
      const { id, brand, name, price, quantity, category, imageUrl } =
        action.payload!;
      if (!state.cartItems.find((item) => item.id === action.payload?.id)) {
        const newItem = {
          id: id,
          brand: brand,
          name: name,
          price: price,
          quantity: quantity,
          category: category,
          imageUrl: imageUrl,
        };
        state.cartItems.push(newItem);
        return {
          ...state,
          ...sumItems(state.cartItems),
          cartItems: [...state.cartItems],
        };
      } else {
        const tempCart = state.cartItems.map((cartItem) => {
          if (cartItem.id === id) {
            const newQuantity = cartItem.quantity + quantity;
            cartItem.quantity = newQuantity;
          }
          return { ...cartItem };
        });
        return { ...state, ...sumItems(tempCart), cartItems: [...tempCart] };
      }
    }
    case CartActionType.RemoveItem: {
      const tempCart = state.cartItems.filter(
        (item) => item.id !== action.payload!.id
      );
      return {
        ...state,
        ...sumItems(tempCart),
        cartItems: [...tempCart],
      };
    }
    default:
      return state;
  }
};

export default CartReducer;
